import React, { useContext, useEffect } from "react";
import { SuccessIcon } from "./Icons";
import { ErrorIcon } from "./Icons";
import { FieldProps } from "../../types";
import { validators } from "../../languages";
import InputControl from "./InputControl";
import MainStateContext from "../../state/mainStateContext";

export function CityField(props: FieldProps) {
  const { formMethods, fieldClasses, inputWrapperClasses, inputClasses, disabled } = props;
  const { setValueChange } = formMethods;
  const { state } = useContext(MainStateContext);
  const { address } = state;

  useEffect(() => {
    setValueChange("city", address.city);
  }, [address.city]);

  return (
    <InputControl
      fieldId="city"
      fieldName="city"
      fieldTitlePhraseKey="payment_step.field_labels.city"
      fieldType="text"
      fieldValue={address.city}
      fieldClasses={fieldClasses}
      inputWrapperClasses={inputWrapperClasses}
      inputClasses={inputClasses}
      labelClasses={"is-required sr-only"}
      formMethods={formMethods}
      attributes={{
        disabled: disabled,
        autoCorrect: "off",
        autoComplete: "address-level2",
        "data-lpignore": "true"
      }}
      errorIcon={<ErrorIcon />}
      successIcon={<SuccessIcon />}
      validators={[validators.required, validators.invalidChars, validators.maxLength(32)]}
    />
  );
}

export default CityField;
